import { Cpu, HardDrive, KeyRound, Mic, PlayCircle, Layers, Clock } from 'lucide-react'
import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const ttsManifest: FeatureManifest = {
  id: 'tts',
  path: 'tts/*',
  navPath: '/tts/engines',
  label: 'Dịch vụ TTS',
  description: 'Quản trị và thử nghiệm tổng hợp giọng nói TTS Hub',
  load: () => import('./entry'),
}

export const ttsNavigationItems = [
  { id: 'tts-engines', path: '/tts/engines', label: 'Engine', Icon: Cpu },
  { id: 'tts-voices', path: '/tts/voices', label: 'Giọng đọc', Icon: Mic },
  { id: 'tts-api-keys', path: '/tts/api-keys', label: 'Khóa API', Icon: KeyRound },
  { id: 'tts-cache', path: '/tts/cache', label: 'Bộ nhớ đệm', Icon: HardDrive },
  { id: 'tts-batch', path: '/tts/batch', label: 'Lô tổng hợp', Icon: Layers },
  { id: 'tts-queue', path: '/tts/queue', label: 'Hàng đợi gom', Icon: Clock },
  { id: 'tts-playground', path: '/tts/playground', label: 'Thử nghiệm', Icon: PlayCircle },
]
